import GroupsIcon from '@mui/icons-material/Groups';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect } from 'react';
import { useGetAllClientsQuery } from '../../../app/Slices/SevenDayApiSlice';
import AllGuestsComponent from '../../components/GuestsManagement/AllGuestsComponent';

export default function GuestListPage() {
    const isMobile = useMediaQuery('(max-width: 770px)');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    //GET REPORT
    const { data: getReport } = useGetAllClientsQuery('/guests');

    return (
        <Grid
            sx={{
                width: '100%',
                height: isMobile ? '100%' : '80%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <Grid
                sx={{
                    width: '100%',
                    height: isMobile ? '2%' : '5%',
                    justifyContent: 'left',
                    display: 'flex',
                }}
            >
                <Typography
                    variant='h1'
                    sx={{
                        textAlign: 'left',
                        textTransform: 'uppercase',
                    }}
                >
                    View All Guests
                </Typography>
            </Grid>

            <Grid sx={{ paddingTop: 3 }}>
                <AllGuestsComponent data={getReport} />
            </Grid>
        </Grid>
    );
}
